const generateSupportItemKey = (urlString) => urlString.replace(':', '_');
export default generateSupportItemKey;
